import { Component } from '@angular/core';

@Component({
    template: `<router-outlet></router-outlet>`
})
export class AuthComponent {
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/auth/auth.component.ts